const menuItems = document.querySelectorAll('.header__menu-item');


menuItems.forEach(item => {
  item.addEventListener('mouseenter', () => {
      // Add the 'hovered' class to the currently hovered item
      item.classList.add('hovered');
      
      // Add 'inactive' class to all other items
      menuItems.forEach(otherItem => {
          if (otherItem !== item) {
              otherItem.classList.add('inactive');
          }
      });
  });

  item.addEventListener('mouseleave', () => {
    let megaMenutem = item.closest(".mega-menu");
    if (!megaMenutem || (megaMenutem && megaMenutem.getAttribute("open") !== 'true')) {

      // Remove the 'hovered' class from the currently hovered item
      item.classList.remove('hovered');
      
      // Remove 'inactive' class from all items
      menuItems.forEach(otherItem => {
          otherItem.classList.remove('inactive');
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const megaMenus = document.querySelectorAll('.mega-menu');
  const overlay = document.querySelector(".js-overlay");

  megaMenus.forEach(menu => {
    menu.addEventListener('mouseenter', function() {
      this.setAttribute('open', true); // Open details
      overlay.style.display = "block";
     
    });

    menu.addEventListener('mouseleave', function() {
      this.removeAttribute('open'); // Close details
      overlay.style.display = "none";

      menuItems.forEach(item => {
        item.classList.remove('inactive');
        item.classList.remove('hovered');
      })
    });
  });
});




const submenuItems = document.querySelectorAll('.level-3-menu__link');

submenuItems.forEach(item => {
  item.addEventListener('mouseenter', () => {
      // Add the 'hovered' class to the currently hovered item
      item.classList.add('hovered');
      
      // Add 'inactive' class to all other items
      submenuItems.forEach(otherItem => {
          if (otherItem !== item) {
              otherItem.classList.add('inactive');
          }
      });
  });

  item.addEventListener('mouseleave', () => {
    // Remove the 'hovered' class from the currently hovered item
    item.classList.remove('hovered');
          
    // Remove 'inactive' class from all items
    submenuItems.forEach(otherItem => {
        otherItem.classList.remove('inactive');
    });
  });  
});